module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "wrapper",
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('Slider', {
    attrs: {
      "list": _vm.list
    }
  })], 1)]), _vm._v(" "), _c('div', {
    ref: "content",
    staticClass: "content"
  }, [_c('div', {
    staticClass: "quick-entry"
  }, [_c('div', {
    staticClass: "entry c1",
    on: {
      "click": function($event) {
        _vm.$router.go({
          name: 'survey-result-list'
        })
      }
    }
  }, [_c('div', {
    staticClass: "icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("我的病历")])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "entry c3",
    on: {
      "click": function($event) {
        _vm.$router.go({
          name: 'survey-list'
        })
      }
    }
  }, [_c('div', {
    staticClass: "icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("疾病风险评估")])]), _vm._v(" "), _c('div', {
    staticClass: "entry c4",
    on: {
      "click": function($event) {
        _vm.$router.go({
          name: 'survey-result-list'
        })
      }
    }
  }, [_c('div', {
    staticClass: "icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("病历历史")])])]), _vm._v(" "), _c('div', {
    staticClass: "article-title"
  }, [_vm._v("\n            文章精选\n            "), _c('span', {
    staticClass: "right",
    on: {
      "click": function($event) {
        _vm.$router.go({
          name: 'news'
        })
      }
    }
  }, [_vm._v("更多")])]), _vm._v(" "), _c('div', {
    staticClass: "article-list"
  }, _vm._l((_vm.list), function(item) {
    return _c('ArticleListItem', {
      attrs: {
        "item": item
      }
    })
  }))]), _vm._v(" "), _c('BottomBar', {
    attrs: {
      "index": 0
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "entry c2"
  }, [_c('div', {
    staticClass: "icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("上传化验单")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-471d2369!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/index.vue
// module id = 231
// module chunks = 1